module.exports = __webpack_public_path__ + "static/media/arrow-dropdown-menu.4ce81c72.svg";